import { Box } from '@mui/material';
import {
  CustomIcons,
  ForgotPasswordModal,
  LoginForm
} from 'modules';
import { useState } from 'react';



export type LoginSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: LoginSectionProps) => {
  const [
    forgotPasswordIsVisible,
    setForgotPasswordIsVisible
  ] = useState(false);

  const handleForgotPassword = () => {
    setForgotPasswordIsVisible(() => false);
  };

  return (
    <>
      {forgotPasswordIsVisible && (
        <ForgotPasswordModal.FC
          isVisible={forgotPasswordIsVisible}
          handleClose={handleForgotPassword}

        />
      )}
      <Box
        marginTop='8rem'
        maxWidth='50rem'
      >
        <CustomIcons.LargeIcon.FC
          icon='MAGNIFYINGGLASS'
        />
        <LoginForm.FC
          handleForgotPassword={() => setForgotPasswordIsVisible(() => true)}
        />
      </Box>
    </>
  );
};
